import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgTrophy = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.1667 5.33496H17.5556V3.94641C17.5556 3.48472 17.184 3.11328 16.7222 3.11328H7.27778C6.81597 3.11328 6.44444 3.48472 6.44444 3.94641V5.33496H2.83333C2.37153 5.33496 2 5.7064 2 6.16809V8.11206C2 9.35134 2.78125 10.6253 4.14931 11.6077C5.24306 12.3957 6.57292 12.8956 7.96875 13.0553C9.05903 14.8639 10.3333 15.6102 10.3333 15.6102V18.1096H8.66667C7.44097 18.1096 6.44444 18.8282 6.44444 20.0536V20.4702C6.44444 20.6993 6.63194 20.8867 6.86111 20.8867H17.1389C17.3681 20.8867 17.5556 20.6993 17.5556 20.4702V20.0536C17.5556 18.8282 16.559 18.1096 15.3333 18.1096H13.6667V15.6102C13.6667 15.6102 14.941 14.8639 16.0313 13.0553C17.4306 12.8956 18.7604 12.3957 19.8507 11.6077C21.2153 10.6253 22 9.35134 22 8.11206V6.16809C22 5.7064 21.6285 5.33496 21.1667 5.33496ZM5.44792 9.80609C4.60069 9.19513 4.22222 8.51474 4.22222 8.11206V7.55664H6.45139C6.48611 8.68831 6.65278 9.68112 6.89583 10.549C6.37153 10.3685 5.88194 10.1185 5.44792 9.80609ZM19.7778 8.11206C19.7778 8.67095 19.1632 9.36523 18.5521 9.80609C18.1181 10.1185 17.625 10.3685 17.1007 10.549C17.3438 9.68112 17.5104 8.68831 17.5451 7.55664H19.7778V8.11206Z", fill: props.fill }));
});
export default SvgTrophy;
